<template>
  <div class="list-page-header">
    <h3 class="title">{{ this.$t("student.list_page_title") }}</h3>

    <div class="primary-bulk-actions" v-if="canAction">
      <action-list-button
        :actions="bulkActions"
        :primaryBtnSettings="primaryAction"
      ></action-list-button>
    </div>
    <import-csv-modal
      :name="importModalName"
      title="student.import_student_by_csv"
      :actions="importCSVModalActions"
      :validation-cols="validations"
    >
      <template #template-desc>
        <p class="template-desc">
          {{ $t("common.download") }}
          <a :href="templateLinks[0]" target="_blank">
            {{ $t("student.basic_CSV_template") }}
          </a>
          {{ $t("student.or") }}
          <a :href="templateLinks[1]" target="_blank">
            {{ $t("student.full_CSV_template") }}
          </a>
          {{ $t("common.see_an_example_of_the_format_required") }}
        </p>
      </template>
    </import-csv-modal>
  </div>
</template>

<script>
import ActionListButton from "@/components/Base/ActionListButton";
import ImportCsvModal from "@/components/Base/ImportCsvModal";
import { NotificationStore } from "@/components/NotificationPlugin";
import { validations } from "@/validations/students";
import { initLoader, Message } from "../../../helpers/utils";
import { postFileToS3, saveUploadedLink } from "@/helpers/aws-s3";
import { service_paths } from "@/constants/Services";
import AWSConst from "@/constants/AWS";
import Vue from "vue";
import { student_router_names } from "@/routes/routes";
import omit from "lodash/omit";
const TEMPLATES_URL = process.env.VUE_APP_API_URL + service_paths.download;

export default {
  name: "ListPageHeader",
  components: { ActionListButton, ImportCsvModal },
  props: ["canAction"],
  data() {
    return {
      validations,
      importModalName: "import-students-csv-modal",
      primaryAction: {
        title: this.$t("common.add_new"),
        onClick: () => {
          this.go2AddPage();
        }
      },
      bulkActions: [
        {
          content: this.$t("common.import_file"),
          action: () => {
            this.$modal.show(this.importModalName);
          }
        }
      ],

      templateLinks: [
        `${TEMPLATES_URL}/csv-template/student/basic`,
        `${TEMPLATES_URL}/csv-template/student/full`
      ],

      importCSVModalActions: {
        primary: {
          title: this.$t("common.upload_and_continue"),
          action: this.uploadFileToS3
        }
      }
    };
  },
  methods: {
    go2AddPage() {
      this.$router.push({ name: student_router_names.addPage });
    },

    async uploadFileToS3(file) {
      let loader = initLoader();
      const s3FolderPath = AWSConst.S3_IMPORT_STUDENT_PATH;

      try {
        const savedLink = await postFileToS3(s3FolderPath, file);
        await saveUploadedLink(savedLink, `${service_paths.import}/students`);
        this.$modal.hide(this.importModalName);
        Message.success(
          this.$t("student.your_request_is_waiting_for_approval")
        );
      } finally {
        loader.hide();
      }
    }
  }
};
</script>
